import Taf from './index'
import { getLogger } from 'amkit3-modules/utils/log4js'
import { getURLParam } from 'amkit3-modules/utils/getURLParam'
const logger = getLogger('utils/tafOld/fetch')

// import Toast from '@cmps/Toast/Toast';

const lUid = '50041702'
const pid = '50077020'

const isTest =
  (process.env.NODE_ENV === 'development' || process.env.TEST) && getURLParam('pro') !== '1'
const TestURL = '//testwebsocket.huya.com:8084?timestamp='
const ProdURL = '//cdnws.api.' + 'huya.com?timestamp='

const URL = isTest ? TestURL : ProdURL

// let URL = ProdURL

function callWup(moduleName, funcName, data, unpackFun) {
  const wup = new Taf.Wup()
  wup.setServant(moduleName)
  wup.setFunc(funcName)
  // for dev test
  if (!data.userId || !data.userId.lUid) {
    data.userId && (data.userId.lUid = lUid)
  }
  data.iIsPlayPage = 1
  wup.writeStruct('tReq', data)
  const buffer = wup.encode().getBuffer()
  const timestamp = new Date().getTime()

  return new Promise((resolve, reject) => {
    // Toast.loading()
    Taf.Util.ajax(
      URL + timestamp,
      buffer,
      value => {
        const rsp = new Taf.Wup()
        rsp.decode(value)
        const result = new unpackFun()
        rsp.readStruct('tRsp', result, unpackFun)
        logger.info(funcName, 'req ', data, 'res ', result)
        resolve(result)
        // Toast.hide()
      },
      res => {
        // Toast.hide()
        reject(res)
      },
    )
  })
}

export default callWup
